import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../hooks/use-services.hook";
import styled from "styled-components";
import {PriceComponent} from "../price/price.component";

const LoggedInUserIndicatorBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    ${props => props.theme.screenMediaQuery.smallScreen} {
        flex-direction: column;
    }
`

const LoggedInUserInitialsBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primaryContrast};
    font-size: ${props => props.theme.fontSize.caption};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    border-radius: 50%;
`


export const LoggedInUserIndicatorComponent = observer(() => {
    const services = useServices();

    if(!services.user.isAuthorized) {
        return null;
    }

    const renderAmountAvailable = () => {
        const amount = services.user.profile.organizationCredit;
        if(!amount) {
            return null;
        }


        return (
            <PriceComponent price={amount}/>
        );
    }

    return (
        <LoggedInUserIndicatorBox>
            <LoggedInUserInitialsBox>
                {services.user.profile.getInitials()}
            </LoggedInUserInitialsBox>
            {renderAmountAvailable()}
        </LoggedInUserIndicatorBox>
    )

})